const styles = theme => ({
  mainBox: {
    background: "#fff",
    width: "100%",
    boxShadow: 0,
    borderBottom: "2px solid #ddd",
    height: '100%',
    objectFit: "cover",
    borderRadius: 4,
    mx: 0,
    cursor: "pointer",
  },
  sideBox: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 4,
    cursor: "pointer",
    boxShadow: 0,
    borderBottom: "2px solid #ddd",
  }
});
export default styles;